import React, { useState, useEffect } from "react";
import BoldIcon from "../assets/icons/BoldIcon.svg";
import CircleLineIcon from "../assets/icons/circleLineIcon.svg";
import NumberIconLine from "../assets/icons/NumberIcon.svg";
import FlexIcon from "../assets/icons/flexIcon.svg";
import RotateTextIcon from "../assets/icons/rotateTextIcon.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { jobsEndpoint } from '../constants';

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

import CVLibrary from "../assets/CVLibrary.png";
import Monster from "../assets/Monster.png";
import Adzuna from "../assets/Adzuna.png";
import Reed from "../assets/Reed.png";
import Linkedin from "../assets/Linkedin.png";
import Totaljobs from "../assets/totaljobs.png"; // ADD THIS IMAGE TO YOUR ASSETS
import Upwork from "../assets/upwork.png";
import Indeed from "../assets/indeed.png";

function HiringJob() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [jobId, setJobId] = useState(null);
  const location = useLocation();
  const [isLoadingSuggestions, setIsLoadingSuggestions] = useState(false);
  const [totaljobsStatus, setTotaljobsStatus] = useState(null); // NEW STATE FOR TOTALJOBS STATUS

  const extractText = (value) => {
    if (typeof value === 'string') {
      return value;
    }
    if (typeof value === 'object' && value !== null) {
      if (value.text) return value.text;
      if (value.content) return value.content;
      if (value.message) return value.message;
      return JSON.stringify(value, null, 2);
    }
    return String(value || '');
  };

  useEffect(() => {
    if (location.state?.jobId) {
      setJobId(location.state.jobId);
      setIsLoadingSuggestions(true);
      
      const fetchSuggestions = async () => {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${jobsEndpoint}${location.state.jobId}/job_suggestions/`, {
            headers: {
              'Authorization': `Token ${token}`
            }
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const data = await response.json();
          console.log('Raw AI suggestions data:', data);
          
          const processedSuggestions = {
            suggested_body: extractText(data.suggested_body),
            suggested_requirements: extractText(data.suggested_requirements)
          };
          
          console.log('Processed suggestions:', processedSuggestions);
          setAiSuggestions(processedSuggestions);
        } catch (error) {
          console.error('Error fetching AI suggestions:', error);
          setErrors({ submit: 'Failed to load AI suggestions' });
        } finally {
          setIsLoadingSuggestions(false);
        }
      };
      fetchSuggestions();
    } else {
      console.log(jobId);
    }
  }, [location, navigate]);

  // Form state
const [formData, setFormData] = useState({
  experience_level: '',
  education_level: '',
  required_skills: ['User Experience Design', 'User Interface Design', 'Usability Testing'],
  publishing_platforms: [],
  files_required: false,
  logo: null // Add this line
});

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [aiSuggestions, setAiSuggestions] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionsApplied, setSuggestionsApplied] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "16px",
    maxHeight: "90vh",
    overflowY: "auto"
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const removeSkill = (skillToRemove) => {
    setFormData(prev => ({
      ...prev,
      required_skills: prev.required_skills.filter(skill => skill !== skillToRemove)
    }));
  };

  const togglePlatform = (platform) => {
    setFormData(prev => ({
      ...prev,
      publishing_platforms: prev.publishing_platforms.includes(platform)
        ? prev.publishing_platforms.filter(p => p !== platform)
        : [...prev.publishing_platforms, platform]
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.experience_level.trim()) {
      newErrors.experience_level = 'Experience level is required';
    }
    
    if (!formData.education_level.trim()) {
      newErrors.education_level = 'Education level is required';
    }
    


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
// UPDATED: Post to Totaljobs with job_id
const postToTotaljobs = async () => {
  try {
    const token = localStorage.getItem('token');
    
    const totaljobsPayload = {
      job_id: jobId,  // Just pass the job ID
      use_test: true // Set to false for production
    };

    const response = await fetch(`${jobsEndpoint}totaljobs/post-job/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
      },
      body: JSON.stringify(totaljobsPayload)
    });

    const result = await response.json();
    
    if (response.ok && result.success) {
      setTotaljobsStatus({
        success: true,
        message: 'Successfully posted to Totaljobs!',
        jobs: result.jobs
      });
      return true;
    } else {
      setTotaljobsStatus({
        success: false,
        message: result.error || 'Failed to post to Totaljobs',
        errors: result.errors
      });
      return false;
    }
  } catch (error) {
    console.error('Error posting to Totaljobs:', error);
    setTotaljobsStatus({
      success: false,
      message: `Error: ${error.message}`
    });
    return false;
  }
};

const handlePublish = async () => {
  if (!validateForm()) {
    handleClose();
    return;
  }

  if (formData.publishing_platforms.length === 0) {
    setErrors({ platforms: 'Please select at least one platform' });
    return;
  }

  setIsSubmitting(true);
  setTotaljobsStatus(null);

  try {
    const token = localStorage.getItem('token');
    
    // 1. Initialize FormData
    const uploadData = new FormData();
    
    // 2. Append text fields
    uploadData.append('experience_level', formData.experience_level);
    uploadData.append('education_level', formData.education_level);
    uploadData.append('files_required', formData.files_required);
    
    // 3. Append the Logo file (if the user selected one)
    if (formData.logo) {
      uploadData.append('logo', formData.logo);
    }

    // 4. Append arrays (DRF expects multiple appends for the same key for lists)
    formData.publishing_platforms.forEach(platform => {
      uploadData.append('publishing_platforms', platform);
    });
    
    formData.required_skills.forEach(skill => {
      uploadData.append('required_skills', skill);
    });

    // 5. Execute the Fetch request
    const response = await fetch(`${jobsEndpoint}publish/step4/${jobId}/`, {
      method: 'PUT',
      headers: {
        // IMPORTANT: Do NOT set 'Content-Type': 'application/json' 
        // when sending FormData. The browser needs to set the boundary.
        'Authorization': `Token ${token}`,
      },
      body: uploadData // Use the FormData object here
    });

    if (response.ok) {
      const result = await response.json();
      
      if (formData.publishing_platforms.includes('Totaljobs')) {
        setTotaljobsStatus({ loading: true, message: 'Posting to Totaljobs...' });
        await postToTotaljobs();
      }
      
      setTimeout(() => {
        navigate("/jobs", { 
          state: { 
            message: result.message,
            totaljobsStatus: totaljobsStatus
          } 
        });
      }, totaljobsStatus?.loading ? 2000 : 500);
      
    } else {
      const errorData = await response.json();
      setErrors(errorData);
    }
  } catch (error) {
    console.error('Error publishing job:', error);
    setErrors({ submit: 'An error occurred while publishing the job' });
  } finally {
    setIsSubmitting(false);
    handleClose();
  }
}

  const handleAcceptSuggestions = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${jobsEndpoint}${jobId}/update/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
        },
        body: JSON.stringify({
          body: aiSuggestions.suggested_body,
          requirements: aiSuggestions.suggested_requirements,
        }),
      });

      if (response.ok) {
        setSuggestionsApplied(true);
        setTimeout(() => {
          setAiSuggestions(null);
          setSuggestionsApplied(false);
        }, 2000);
      } else {
        const errorData = await response.json();
        setErrors(errorData);
      }
    } catch (error) {
      console.error('Error accepting suggestions:', error);
      setErrors({ submit: 'An error occurred while accepting the suggestions' });
    }
    setShowSuggestions(false);
  };

  return (
    <div className="w-full inline-flex items-start pb-[8.625rem] p-0">
      <div className="w-full flex flex-col items-start">
        <div className="flex flex-col items-start gap-8 self-stretch pt-8 pb-12">
          <div className="flex flex-col items-start gap-6 self-stretch">
            <div className="container flex flex-col items-start self-stretch pb-[32px] pt-0 px-8">
              <div className="page_header flex flex-col items-start self-stretch">
                <div className="content-10 flex flex-wrap items-start content-start self-stretch">
                  <div className="text_and_supporting_text-2 flex flex-col items-start min-w-[20rem]">
                    <div className="self-stretch text-[#181d27] font-semibold">
                      Create Job
                    </div>
                    <div className="self-stretch text-[#535862]">
                      Here is a complete overview of your jobs.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Progress Steps */}
          <div className="flex flex-col items-center justify-center w-full">
            <div className="flex justify-center items-start w-full">
              <div className="_step_base flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#009c97] lg:text-base text-sm text-center font-semibold">
                    Define your role
                  </div>
                </div>
                <div className="_step_icon_base flex justify-center items-center w-6 h-6 rounded-full bg-[#f9f5ff]">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#19BFB7" />
                    <circle cx={12} cy={12} r={4} fill="white" />
                  </svg>
                </div>
              </div>
              
              <div className="_step_base-1 flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#009c97] text-center font-semibold lg:text-base text-sm">
                    Job Description
                  </div>
                </div>
                <div className="flex justify-center items-center w-6 h-6 rounded-full bg-[#f9f5ff]">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#19BFB7" />
                    <circle cx={12} cy={12} r={4} fill="white" />
                  </svg>
                </div>
              </div>
              
              <div className="_step_base-2 flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#009c97] text-center font-semibold lg:text-base text-sm">
                    Salary & Benefits
                  </div>
                </div>
                <div className="flex justify-center items-center w-6 h-6 rounded-full bg-[#f9f5ff]">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#19BFB7" />
                    <circle cx={12} cy={12} r={4} fill="white" />
                  </svg>
                </div>
              </div>
              
              <div className="_step_base-3 flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#009c97] text-center font-semibold lg:text-base text-sm">
                    Hiring Preferences
                  </div>
                </div>
                <div className="flex justify-center items-center w-6 h-6 rounded-full bg-[#f9f5ff]">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#19BFB7" />
                    <circle cx={12} cy={12} r={4} fill="white" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Form Content */}
          <div className="flex w-full items-start gap-6">
            <div className="flex flex-col w-full items-start gap-10 pb-[32px] pt-0 px-8">
              <div className="flex md:flex-row flex-col w-full items-start gap-6">
                <div className="flex flex-col items-start gap-1">
                  <div className="text_wrapper flex items-center">
                    <div className="text-[#414651] font-semibold leading-6">
                      Hiring Preferences
                    </div>
                    <div className="text-[#009c97] font-semibold">*</div>
                  </div>
                  <div className="self-stretch text-[#535862]">
                    Find the right fit with AI-powered screening!
                  </div>
                </div>

                {/* Form Fields */}
                <div className="frame_1597884787 flex flex-col justify-center items-start gap-6">
                  <div className="flex items-center gap-6 self-stretch">
                    <div className="input_field-4 flex flex-col items-start">
                      <div className="input_with_label-5 flex flex-col items-start self-stretch">
                        <div className="label_wrapper-4 flex items-start">
                          <div className="text-[#414651] font-medium">
                            Experience Level
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="input-5 flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                          <div className="text-gray-700 content-24 flex items-center py-2 pl-3 w-full">
                            <select 
                              name="experience_level"
                              value={formData.experience_level}
                              onChange={handleInputChange}
                              className="w-full cursor-pointer mr-3 outline-none text-gray-700"
                            >
                              <option value="">Choose experience level</option>
                              <option value="Entry Level">Entry Level</option>
                              <option value="Mid Level">Mid Level</option>
                              <option value="Senior Level">Senior Level</option>
                              <option value="Executive">Executive</option>
                            </select>
                          </div>
                        </div>
                        {errors.experience_level && <span className="text-red-500 text-sm">{errors.experience_level}</span>}
                      </div>
                    </div>
                    
                    <div className="input_field-5 flex flex-col items-start">
                      <div className="input_with_label-6 flex flex-col items-start self-stretch">
                        <div className="label_wrapper-5 flex items-start">
                          <div className="text-[#414651] font-medium">
                            Education Level
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="input-6 flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                          <div className="text-gray-700 content-25 flex items-center py-2 pl-3 w-full">
                            <select 
                              name="education_level"
                              value={formData.education_level}
                              onChange={handleInputChange}
                              className="w-full cursor-pointer mr-3 outline-none text-gray-700"
                            >
                              <option value="">Choose education level</option>
                              <option value="High School">High School</option>
                              <option value="Bachelor's Degree">Bachelor's Degree</option>
                              <option value="Master's Degree">Master's Degree</option>
                              <option value="PhD">PhD</option>
                              <option value="Professional Certification">Professional Certification</option>
                            </select>
                          </div>
                        </div>
                        {errors.education_level && <span className="text-red-500 text-sm">{errors.education_level}</span>}
                      </div>
                    </div>
                  </div>



                  {/* Files Required Section */}
                  <div className="flex flex-col items-start gap-4 self-stretch p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <div className="flex items-start gap-3">
                      <input
                        type="checkbox"
                        id="files_required"
                        name="files_required"
                        checked={formData.files_required}
                        onChange={handleInputChange}
                        className="mt-1 w-5 h-5 text-[#19BFB7] border-gray-300 rounded focus:ring-[#19BFB7] cursor-pointer"
                      />
                      <div className="flex flex-col gap-1">
                        <label htmlFor="files_required" className="text-[#414651] font-semibold cursor-pointer">
                          Require Supporting Documents
                        </label>
                        <p className="text-[#535862] text-sm">
                          Will applicants need to provide supporting documents such as passports, proof of residence, certifications, or other verification files?
                        </p>
                        {formData.files_required && (
                          <div className="mt-2 p-3 bg-white border border-blue-300 rounded-md">
                            <p className="text-sm text-[#414651]">
                              <strong>📄 Enabled:</strong> Applicants will be prompted to upload required documents during the application process.
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
<div className="input_field flex flex-col items-start gap-2">
  <label className="text-[#414651] font-medium">Company Logo</label>
  <input 
    type="file" 
    accept="image/*"
    onChange={(e) => setFormData(prev => ({ ...prev, logo: e.target.files[0] }))}
    className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#19bfb7] file:text-white hover:file:bg-[#16a8a1]"
  />
</div>
                  {/* Loading state for AI suggestions */}
                  {isLoadingSuggestions && (
                    <div className="w-full flex flex-col gap-3 p-4 border border-gray-200 rounded-lg bg-gray-50">
                      <div className="flex items-center gap-3">
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#19BFB7]"></div>
                        <h5 className="text-gray-700 text-[16px] font-semibold">
                          Generating AI Recommendations...
                        </h5>
                      </div>
                      <p className="text-gray-500 text-sm">
                        Please wait while we analyze your job posting and generate personalized suggestions.
                      </p>
                    </div>
                  )}

                  {/* Error Display */}
                  {errors.submit && (
                    <div className="text-red-500 text-sm">{errors.submit}</div>
                  )}
                  {errors.platforms && (
                    <div className="text-red-500 text-sm">{errors.platforms}</div>
                  )}

                  {/* AI Suggestions Display */}
                  {aiSuggestions && !isLoadingSuggestions && (
                    <div className="w-full flex flex-col gap-4 p-4 border border-green-200 rounded-lg bg-green-50">
                      {suggestionsApplied ? (
                        <div className="flex items-center justify-center gap-3 py-8">
                          <div className="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center">
                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                          </div>
                          <div className="text-center">
                            <h5 className="text-green-800 text-[16px] font-semibold">
                              ✅ AI Suggestions Applied Successfully!
                            </h5>
                            <p className="text-green-600 text-sm">Your job post has been updated with AI recommendations.</p>
                          </div>
                        </div>
                      ) : (
                        <>
                          <h5 className="text-gray-800 text-[16px] font-semibold">
                            🤖 AI Recommendations Ready
                          </h5>
                          <div className="w-full flex flex-col gap-3">
                            <div>
                              <h6 className="text-gray-800 font-semibold mb-2">Suggested Body:</h6>
                              <textarea 
                                readOnly 
                                value={extractText(aiSuggestions.suggested_body)} 
                                className="w-full h-32 border border-gray-300 rounded-md p-3 text-gray-800 bg-white resize-none focus:outline-none" 
                                placeholder="AI suggestion will appear here..."
                              />
                            </div>
                            <div>
                              <h6 className="text-gray-800 font-semibold mb-2">Suggested Requirements:</h6>
                              <textarea 
                                readOnly 
                                value={extractText(aiSuggestions.suggested_requirements)} 
                                className="w-full h-32 border border-gray-300 rounded-md p-3 text-gray-800 bg-white resize-none focus:outline-none" 
                                placeholder="AI suggestion will appear here..."
                              />
                            </div>
                            <button 
                              onClick={() => {
                                const processedBody = extractText(aiSuggestions.suggested_body);
                                const processedRequirements = extractText(aiSuggestions.suggested_requirements);
                                
                                setFormData(prev => ({
                                  ...prev, 
                                  body: processedBody, 
                                  requirements: processedRequirements
                                }));
                                handleAcceptSuggestions();
                              }} 
                              className="bg-[#19BFB7] hover:bg-[#17ACA5] text-white font-semibold py-3 px-6 rounded-lg shadow transition-colors duration-200" 
                            >
                              ✨ Apply AI Suggestions
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  )}

                  {/* NEW: Totaljobs Status Display */}
                  {totaljobsStatus && (
                    <div className={`w-full flex flex-col gap-3 p-4 border rounded-lg ${
                      totaljobsStatus.success 
                        ? 'border-green-200 bg-green-50' 
                        : totaljobsStatus.loading
                        ? 'border-blue-200 bg-blue-50'
                        : 'border-red-200 bg-red-50'
                    }`}>
                      <div className="flex items-center gap-3">
                        {totaljobsStatus.loading ? (
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
                        ) : totaljobsStatus.success ? (
                          <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                        ) : (
                          <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        )}
                        <h5 className={`text-[16px] font-semibold ${
                          totaljobsStatus.success 
                            ? 'text-green-800' 
                            : totaljobsStatus.loading
                            ? 'text-blue-800'
                            : 'text-red-800'
                        }`}>
                          {totaljobsStatus.loading ? '📤 Posting to Totaljobs...' : totaljobsStatus.message}
                        </h5>
                      </div>
                      {totaljobsStatus.errors && (
                        <div className="text-sm text-red-600">
                          {JSON.stringify(totaljobsStatus.errors)}
                        </div>
                      )}
                    </div>
                  )}</div>
              </div>

              {/* Action Buttons */}
              <div className="actions-1 flex justify-end items-center self-stretch gap-4">
                <button
                  type="button"
                  onClick={() => navigate("/salary_job")}
                  className="border border-gray-300 rounded-lg text-gray-700 cursor-pointer px-4 py-2 hover:bg-gray-50 transition-colors"
                >
                  Back
                </button>
                <button
                  onClick={handleOpen}
                  disabled={isSubmitting || isLoadingSuggestions}
                  className={`rounded-lg text-white cursor-pointer px-6 py-2 transition-colors ${
                    isSubmitting || isLoadingSuggestions 
                      ? 'bg-gray-400 cursor-not-allowed' 
                      : 'bg-[#19bfb7] hover:bg-[#16a8a1]'
                  }`}
                >
                  {isSubmitting ? 'Publishing...' : isLoadingSuggestions ? 'Generating Recommendations...' : 'Publish'}
                </button>
              </div>

              {/* Publishing Platforms Modal */}
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    className="text-gray-700 text-lg font-semibold"
                  >
                    <h3 className="text-gray-700 font-semibold text-[18px]">
                      Publish Job Post
                    </h3>
                  </Typography>
                  <Typography id="modal-modal-description">
                    <p className="text-gray-400 pb-4 text-sm">
                      Choose the preferred platforms where you would like to post the job.
                    </p>
                  </Typography>
                  <Typography variant="div">
                    <div className="flex items-center gap-3 border-t border-gray-300 pt-6 justify-center flex-wrap">
                      {[
                        { name: 'Reed', image: Reed },
                        { name: 'LinkedIn', image: Linkedin },
                        { name: 'Totaljobs', image: Totaljobs, isNew: true },
                        { name: 'Adzuna', image: Adzuna },
                        { name: 'Monster', image: Monster },
                        { name: 'CVLibrary', image: CVLibrary }
                      ].map((platform) => (
                        <div 
                          key={platform.name}
                          className={`relative border p-3 rounded-lg flex flex-col gap-2 cursor-pointer transition-all min-w-[90px] ${
                            formData.publishing_platforms.includes(platform.name)
                              ? 'border-[#19bfb7] bg-[#f0fffe] shadow-md scale-105'
                              : 'border-gray-300 hover:border-gray-400 hover:shadow'
                          }`}
                          onClick={() => togglePlatform(platform.name)}
                        >
                          {/* NEW BADGE */}
                          {platform.isNew && (
                            <div className="absolute -top-2 -right-2 bg-green-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                              NEW
                            </div>
                          )}
                          <img 
                            src={platform.image} 
                            alt={platform.name} 
                            className="w-10 h-10 mx-auto object-contain" 
                          />
                          <h5 className={`text-center text-xs font-semibold ${
                            formData.publishing_platforms.includes(platform.name)
                              ? 'text-[#19bfb7]'
                              : 'text-gray-700'
                          }`}>
                            {platform.name}
                          </h5>
                          {formData.publishing_platforms.includes(platform.name) && (
                            <div className="absolute top-1 right-1 w-5 h-5 bg-[#19bfb7] rounded-full flex items-center justify-center">
                              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                              </svg>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    
                    {/* Platform Info for Totaljobs */}
                    {formData.publishing_platforms.includes('Totaljobs') && (
                      <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                        <div className="flex items-start gap-2">
                          <svg className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <div className="flex-1">
                            <p className="text-sm text-blue-800 font-semibold">
                              Totaljobs Integration
                            </p>
                            <p className="text-xs text-blue-600 mt-1">
                              Your job will be posted to Totaljobs using your integrated account. Make sure all required fields are filled correctly.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </Typography>
                  <Typography>
                    <div className="flex gap-5 items-center w-full mt-6">
                      <button 
                        onClick={handleClose}
                        className="rounded-lg px-4 py-2 border border-gray-300 text-gray-700 w-full cursor-pointer hover:bg-gray-50 transition-colors"
                      >
                        Cancel
                      </button>
                      <button 
                        onClick={handlePublish}
                        disabled={isSubmitting}
                        className={`text-white rounded-lg px-4 py-2 w-full cursor-pointer transition-colors ${
                          isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#009C97] hover:bg-[#007d7a]'
                        }`}
                      >
                        {isSubmitting ? 'Publishing...' : 'Confirm'}
                      </button>
                    </div>
                  </Typography>
                </Box>
              </Modal>

              {/* AI Suggestions Modal */}
              <Modal
                open={showSuggestions}
                onClose={() => setShowSuggestions(false)}
                aria-labelledby="ai-suggestions-title"
                aria-describedby="ai-suggestions-description"
              >
                <Box sx={style}>
                  <Typography id="ai-suggestions-title" className="text-gray-700 text-lg font-semibold">
                    AI Suggestions
                  </Typography>
                  <Typography id="ai-suggestions-description">
                    <p className="text-gray-400 pb-4 text-sm">
                      Our AI has suggested some improvements for your job post.
                    </p>
                    {aiSuggestions && (
                      <div>
                        <h4 className="text-gray-700 font-semibold">Suggested Body:</h4>
                        <textarea 
                          readOnly 
                          value={extractText(aiSuggestions.suggested_body)} 
                          className="w-full h-32 border rounded-md p-2 my-2 text-gray-800" 
                        />
                        <h4 className="text-gray-700 font-semibold">Suggested Requirements:</h4>
                        <textarea 
                          readOnly 
                          value={extractText(aiSuggestions.suggested_requirements)} 
                          className="w-full h-32 border rounded-md p-2 my-2 text-gray-800" 
                        />
                      </div>
                    )}
                  </Typography>
                  <div className="flex gap-5 items-center w-full mt-10">
                    <button
                      onClick={() => setShowSuggestions(false)}
                      className="rounded-lg px-4 py-2 border border-gray-300 text-gray-700 w-full cursor-pointer hover:bg-gray-50 transition-colors"
                    >
                      Decline
                    </button>
                    <button
                      onClick={handleAcceptSuggestions}
                      className="text-white rounded-lg px-4 py-2 w-full cursor-pointer bg-[#009C97] hover:bg-[#007d7a] transition-colors"
                    >
                      Accept
                    </button>
                  </div>
                </Box>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HiringJob;